import { useQueryClient } from 'react-query';

const useInvalidateQueries = () => {
  const queryClient = useQueryClient();

  const invalidateQueries = (queryKeys: string[], callback?: () => void) => {
    queryKeys.forEach(key => queryClient.invalidateQueries(key));
    queryClient.invalidateQueries('tabCounts');
    if (callback) callback();
  };

  return invalidateQueries;
};

export default useInvalidateQueries;
